module.exports = __webpack_public_path__ + "static/media/parks2go_logo.d4221cbb.png";